import { createFileRoute } from "@tanstack/react-router";

import { PnLPage } from "@/features/qbo/ui/PnLPage";

export const Route = createFileRoute("/_authenticated/pnl")({
  component: PnLPage,
});
